export const mapCubicBezierArrayToString = (
  array: number[] | number | string
): string | number => {
  if (!Array.isArray(array)) return array;
  const stringifiedArray = array.reduce(
    (result, item) => (result ? `${result}, ${item}` : `${item}`),
    ""
  );
  return `cubic-bezier(${stringifiedArray})`;
};
